function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { setCookie } from "services/cookies-service";
import { CONTACT_SALES_FORM_DATA } from "constants/cookies";
import { getValueFromHSFields } from "client/services/hubspot-service/hubspot-service";
import { HUBSPOT_API_FIRSTNAME } from "client/services/hubspot-service/hubspot-constants";
import { getCalendarLink } from "services/contact-sales";
import { trackEvent } from "services/bigbrain-service";
import * as Sentry from "@sentry/nextjs";
import { BOOK_A_MEETING_ELIGIBILITY_RESPONSE_ERROR, BOOK_A_MEETING_ELIGIBILITY_RESPONSE_TIME, BOOK_A_MEETING_ELIGIBILITY_TIMEOUT_EXCEEDED } from "constants/bigbrain-event-types";
import { CHILIPIPER_LINK_TIMESTAMP, CHILIPIPER_TIMEOUT, CHILIPIPER_URL } from "segments/desktop/embedded/layouts/book-a-meeting-embedded/book-a-meeting-embedded-consts";
const BOOK_A_MEETING_NAME_QUERY_PARAM_KEY = "name";
const DEFAULT_TIMEOUT = 10000; // 10 seconds
const FIELDS_MAPPING = {
    firstname: "contactSalesFirstName",
    lastname: "contactSalesLastName",
    email: "contactSalesEmail",
    jobtitle: "contactSalesJobTitle",
    phone: "contactSalesPhone",
    company: "contactSalesCompany",
    company_size__c: "contactSalesCompanySize",
    product_question_hs_forms: "contactSalesProductQuestion",
    how_can_our_consulting_team_help_you: "contactSalesOpenText"
};
export const transformDataToAdaFormat = (input)=>{
    const result = {};
    input.forEach((item)=>{
        const { name, value } = item;
        const mappedKey = FIELDS_MAPPING[name];
        if (mappedKey) {
            var _value_;
            if (Array.isArray(value) && ((_value_ = value[0]) === null || _value_ === void 0 ? void 0 : _value_.value)) {
                result[mappedKey] = value[0].value;
            } else if (value === null || value === void 0 ? void 0 : value.value) {
                result[mappedKey] = value.value;
            } else {
                result[mappedKey] = value;
            }
        }
    });
    return result;
};
const getMeetingCalenderDetails = function() {
    var _ref = _async_to_generator(function*(formData, enrichmentCS, timeout = DEFAULT_TIMEOUT) {
        const startTime = performance.now();
        try {
            const clientTimezoneOffset = new Date().getTimezoneOffset();
            const bamCalenderResponse = yield getCalendarLink(_object_spread_props(_object_spread({}, formData), {
                cs: enrichmentCS,
                clientTimezoneOffset
            }), timeout);
            trackEvent(BOOK_A_MEETING_ELIGIBILITY_RESPONSE_TIME, {
                kind: Math.round(performance.now() - startTime),
                info1: !!(bamCalenderResponse === null || bamCalenderResponse === void 0 ? void 0 : bamCalenderResponse.calendarLink)
            });
            return bamCalenderResponse;
        } catch (error) {
            if ((error === null || error === void 0 ? void 0 : error.name) === "AbortError") {
                trackEvent(BOOK_A_MEETING_ELIGIBILITY_TIMEOUT_EXCEEDED, {
                    kind: timeout
                });
                return null;
            }
            Sentry.captureException(error);
            Sentry.captureMessage(`Error occurred while getting BAM link : ${(error === null || error === void 0 ? void 0 : error.message) || error}`);
            trackEvent(BOOK_A_MEETING_ELIGIBILITY_RESPONSE_ERROR, {
                kind: (error === null || error === void 0 ? void 0 : error.message) || error,
                info1: Math.round(performance.now() - startTime)
            });
            return null;
        }
    });
    return function getMeetingCalenderDetails(formData, enrichmentCS) {
        return _ref.apply(this, arguments);
    };
}();
const getBAMRedirectUrlWithQueryParams = (bookAMeetingUrl, firstName)=>{
    try {
        if (!firstName) return bookAMeetingUrl;
        const url = new URL(bookAMeetingUrl, window.location.origin);
        url.searchParams.set(BOOK_A_MEETING_NAME_QUERY_PARAM_KEY, firstName);
        return url.toString();
    } catch (error) {
        Sentry.captureMessage(`error occur on calculating BAM redirect url with nam query param, ${error.message}`);
        return bookAMeetingUrl;
    }
};
export const setAdaOnPage = (formData)=>{
    setCookie(CONTACT_SALES_FORM_DATA, transformDataToAdaFormat(formData));
};
export const setBookAMeetingInfoOnPage = function() {
    var _ref = _async_to_generator(function*(formData, enrichment, bookAMeetingUrl, timeout) {
        var _localStorage, _localStorage1, _localStorage2;
        if (!bookAMeetingUrl) return null;
        const formFieldsObject = Object.fromEntries(formData.map(({ name, value })=>[
                name,
                value
            ]));
        const calendarDetails = yield getMeetingCalenderDetails(formFieldsObject, enrichment === null || enrichment === void 0 ? void 0 : enrichment.cs, timeout);
        if (!(calendarDetails === null || calendarDetails === void 0 ? void 0 : calendarDetails.calendarLink)) return null;
        const firstName = getValueFromHSFields(formData, HUBSPOT_API_FIRSTNAME);
        (_localStorage = localStorage) === null || _localStorage === void 0 ? void 0 : _localStorage.setItem(CHILIPIPER_URL, calendarDetails.calendarLink);
        (_localStorage1 = localStorage) === null || _localStorage1 === void 0 ? void 0 : _localStorage1.setItem(CHILIPIPER_TIMEOUT, calendarDetails === null || calendarDetails === void 0 ? void 0 : calendarDetails.calendarLinkTimeoutInMS);
        (_localStorage2 = localStorage) === null || _localStorage2 === void 0 ? void 0 : _localStorage2.setItem(CHILIPIPER_LINK_TIMESTAMP, Date.now());
        return getBAMRedirectUrlWithQueryParams(bookAMeetingUrl, firstName);
    });
    return function setBookAMeetingInfoOnPage(formData, enrichment, bookAMeetingUrl, timeout) {
        return _ref.apply(this, arguments);
    };
}();
